import {Injectable} from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";
import {NgxSpinnerService} from "ngx-spinner";


@Injectable({
  providedIn: 'root'
})
export class GuiService {

   public static instance:any = null;

   constructor(private spinner: NgxSpinnerService,
               private sanitizer: DomSanitizer) {
      GuiService.instance = this;
   }

   public async showLoading(){
      await this.spinner.show();
      return Promise.resolve(null);
   }

   public async hideLoading(){
      await this.spinner.hide();
      return Promise.resolve(null);
   }

   public getImageUrl(image:any){
      // [style.background-image]="guiSrv.getImageUrl(dataSrv.BrandSelezionato.image)"
      return this.sanitizer.bypassSecurityTrustStyle(`url(${image})`);
   }

}
